import {
    REPORT_LIST_REQUEST,
    REPORT_LIST_RESPONSE,
    REPORT_LIST_CACHED_RESPONSE,
    REPORT_LIST_ERROR_RESPONSE
} from "../actions/action-types"
import {
    reportListCachedResponse,
    reportListErrorResponse,
    reportListResponse
} from "../actions/report-actions"
import { getReportsList } from "../api/report-api"
import {
    requestListEpic,
    callbackActionCreatorEpic
} from "./default-epics/default-entity-epics"

export const requestReportListEpic = requestListEpic(
    REPORT_LIST_REQUEST,
    getReportsList,
    "reports",
    reportListResponse,
    reportListCachedResponse,
    reportListErrorResponse
)

export const responseReportCallbackEpic = callbackActionCreatorEpic(
    REPORT_LIST_RESPONSE,
    REPORT_LIST_CACHED_RESPONSE,
    REPORT_LIST_ERROR_RESPONSE
)
